import React from 'react';

export default class EmailField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectionStart: 0,
            selectionEnd: 0,
            caretPos: 0,
            lastUpdate: ''
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (document.activeElement === this.refs.input) {
            if (prevState !== this.state || prevProps.value !== this.props.value) {
                this.setCaretSelection();
            }
        }
    }

    update = (e) => {
        let addDomain = !this.props.emailIgnoreDomain;
        const { lastUpdate } = this.state;
        let { value } = e.target;

        if (lastUpdate === value || lastUpdate.length > value.length) {
            addDomain = false;
        }

        this.setState({ lastUpdate: value, caretPos: e.target.selectionStart }, () => {
            this.props.update('email_address', addDomain ? this.appendDomain(this.state.lastUpdate) : this.state.lastUpdate);
        });
    }

    focus = () => {
        // Hack to put the caret position at the end of the text
        this.setCaretSelection(this.setAndReturnDomain('', '', 999, 999));
    }

    setCaretSelection = () => {
        const { input } = this.refs;
        let { selectionStart, selectionEnd, caretPos } = this.state;

        if (caretPos && !(selectionStart && selectionEnd)) {
            selectionStart = selectionEnd = caretPos;
        }

        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    }

    setAndReturnDomain = (oldValue, newValue, customStart, customEnd) => {
        this.setState({
            selectionStart: customStart || oldValue.length,
            selectionEnd: customEnd || newValue.length
        });

        return newValue;
    }

    appendDomain = (value) => {
        if (value && this.props.domains.length && value.length) {
            const { caretPos } = this.state;

            if (value.indexOf('@') < 0) {
                return this.setAndReturnDomain(value, value + '@' + this.props.domains[0]);
            } else {
                const ampFind = value.match(/^.*@(.*)$/);

                if (ampFind !== null && ampFind.length) {
                    if (ampFind[1].length === 0) {
                        // Has an @ but nothing else
                        return this.setAndReturnDomain(value, value + this.props.domains[0]);
                    } else {
                        for (let i = 0; i < this.props.domains.length; i++) {
                            const domainCached = this.props.domains[i];

                            if (domainCached.substring(0, ampFind[1].length) === ampFind[1]) {
                                const newValue = value + domainCached.substring(ampFind[1].length, domainCached.length);
                                return this.setAndReturnDomain(
                                    value,
                                    newValue,
                                    value.length === newValue.length ? caretPos : null,
                                    value.length === newValue.length ? caretPos : null
                                );
                            }
                        }
                    }
                }
            }
        }

        return this.setAndReturnDomain(value, value);
    }
    
    render() {
        return (
            <input
                type="text"
                ref="input"
                className="cellLike"
                disabled={ this.props.readOnly }
                value={ this.props.value }
                onChange={ this.update }
                style={ { fontSize: 9, width: '100%' } } />
        );
    }

};
